/**
 * @param state {object} Domain state
 * @param cartId {string} Cart id
 * @param cartItemIds {string[]}
 * @returns {object} Updated domain state
 */
export default (state, {cartId, cartItemIds}) => {

    const cartItems = state.carts[cartId].items;
    state.carts[cartId].items = cartItems.filter(cartItem => !cartItemIds.includes(cartItem.itemId));

    return state;
};
